import { render, staticRenderFns } from "./LessonsEdit.vue?vue&type=template&id=f47fd952"
import script from "./LessonsEdit.vue?vue&type=script&lang=js"
export * from "./LessonsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports